/* Auto-generated from 产品目录 Excel — run: node scripts/generate-catalog.js */
export const catalogSeries = [
  {
    "key": "defoamer",
    "slug": "defoamer",
    "name": "消泡剂系列",
    "sheet": "消泡剂",
    "headerMap": {
      "spec4": "粘度（25℃，cps）",
      "spec5": "比重（25℃，g/cm³）"
    },
    "categories": [
      {
        "key": "df640-4",
        "name": "DF640"
      },
      {
        "key": "df580-5",
        "name": "DF580"
      },
      {
        "key": "df581-6",
        "name": "DF581"
      },
      {
        "key": "df690-7",
        "name": "DF690"
      }
    ],
    "products": [
      {
        "key": "df640-4",
        "name": "DF640",
        "model": "DF640",
        "intro": "无APEO、无溶剂、高环保合规 ，优异的破泡速度与长效抑泡能力 ，高剪切稳定性 ，适配高粘度体系 ，对漆膜光泽无影响",
        "features": "无APEO、无溶剂、高环保合规 ，优异的破泡速度与长效抑泡能力 ，高剪切稳定性",
        "scope": "高端家具漆、工业面漆 、高粘度乳液体系、水性油墨、食品接触级涂料",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.88–0.92"
        }
      },
      {
        "key": "df580-5",
        "name": "DF580",
        "model": "DF580",
        "intro": "通用经济型主力款 ，破泡速度快 ，耐酸碱性能优异 ，不含APEO ，对涂料光泽无影响 ，储存稳定性好 ，全阶段泡沫控制能力",
        "features": "破泡速度快 ，耐酸碱性能优异 ，不含APEO ，对涂料光泽无影响 ，储存稳定性好",
        "scope": "建筑涂料、丝光/高光面漆、水性胶粘剂、乳液合成、农业喷雾、印花色浆",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.91-0.95"
        }
      },
      {
        "key": "df581-6",
        "name": "DF581",
        "model": "DF581",
        "intro": "DF580升级优化款 ，抑泡持久性、储存稳定性显著提升 ，高剪切稳定性，适配高要求建筑涂料与工业涂料 ，无缩孔风险",
        "features": "抑泡持久性、储存稳定性显著提升 ，高剪切稳定性",
        "scope": "中高端建筑涂料、工业面漆、水性胶粘剂、高要求乳液体系、水性木器漆",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.91-0.95"
        }
      },
      {
        "key": "df690-7",
        "name": "DF690",
        "model": "DF690",
        "intro": "快速消泡、消泡持久、经济性突出 ，能在水中快速分散 ，不含硅酮 ，适配多种水性体系 ，耐酸碱 ，储存稳定性好",
        "features": "快速消泡、消泡持久、经济性突出 ，能在水中快速分散 ，适配多种水性体系 ，耐酸碱 ，储存稳定性好",
        "scope": "乳液类涂料、纸品涂料 、农业喷雾、粘合剂、印花色浆、地板清洁化合物、污水处理系统",
        "data": {
          "spec4": "800-1500",
          "spec5": "0.83-0.85"
        }
      }
    ]
  },
  {
    "key": "fastT",
    "slug": "fast-t",
    "name": "快T系列",
    "sheet": "快T",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "外观"
    },
    "categories": [
      {
        "key": "快t无水-4",
        "name": "快T(无水)"
      },
      {
        "key": "快t乙醇水-5",
        "name": "快T(乙醇水)"
      },
      {
        "key": "快t溶剂油-6",
        "name": "快T(溶剂油)"
      }
    ],
    "products": [
      {
        "key": "快t无水-4",
        "name": "快T(无水)",
        "model": "快T(无水)",
        "intro": "极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。环保低泡：零 VOC、无 APEO、不易泛黄；50℃以上低泡，低温稳泡。",
        "features": "超强润湿 / 渗透：极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。\n乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。\n环保低泡：零 VOC、无 APEO、不易泛黄；50℃以上低泡，低温稳泡。",
        "scope": "水性体系润湿、分散、抗缩孔，调节水墨粘度。\n农药：乳油 / 水剂渗透剂，提升药液铺展与吸收。\n纺织 / 皮革：渗透、匀染、柔软、抗静电，改善织物抱合性。\n乳液聚合：乳化剂，提高乳液稳定性与粒径控制。\n医药 / 日化：药膏、乳膏乳化分散；洗面奶、沐浴露增溶稳泡。",
        "data": {
          "spec4": "＞98",
          "spec5": "白色 / 类白色结晶粉末或蜡状固体"
        }
      },
      {
        "key": "快t乙醇水-5",
        "name": "快T(乙醇水)",
        "model": "快T(乙醇水)",
        "intro": "极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。环保低泡",
        "features": "超润湿 + 强渗透：极低表面张力，快速铺展、渗透到纤维 / 基材内部\n低泡 / 抑泡：非高泡型，可协同消泡剂，不易起大泡\n乳化稳定：阴离子型，与非离子两性配伍好；乳液聚合常用乳化剂\n低毒、易生物降解：环保型，废水易处理\n抗硬水：耐钙镁离子，适用多种水质",
        "scope": "乳液聚合（丙烯酸 / 苯丙）：乳化剂，提高稳定性、粒径均匀、降低起泡\n涂料 / 油墨：润湿流平、防缩孔 / 鱼眼 / 针孔、改善底材润湿\n胶粘剂 / 压敏胶：涂布防收缩、提高浸润、防针孔 / 流挂\n无纺布 / 纺织：快速渗透纤维、固色 / 粘合更均匀\n水处理 / 金属加工：润湿分散、除油、低泡清洗",
        "data": {
          "spec4": "72–74 ",
          "spec5": "无色至浅黄色透明微粘液体"
        }
      },
      {
        "key": "快t溶剂油-6",
        "name": "快T(溶剂油)",
        "model": "快T(溶剂油)",
        "intro": "真正无水：水分＜0.5%，可溶乳油、油悬剂、粉剂（普通快 T 含水 30–50%，只能做水剂）\n渗透力极强：1% 溶液≤5 秒，比 JFC、氮酮快 3–10 倍\n润湿 + 乳化 + 展着 + 分散四合一\n耐硬水、耐电解质，与多数阴离子 / 非离子复配\n低泡型，适合高浓度配方",
        "features": "真正无水：水分＜0.5%，可溶乳油、油悬剂、粉剂（普通快 T 含水 30–50%，只能做水剂）\n在油性涂层、油墨、胶黏剂、金属加工油中铺展更好\n对金属、玻璃、塑料薄膜难润湿基材依然高效",
        "scope": "农药制剂:EC 乳油、EW 水乳、ME 微乳、SC 悬浮、WG 水分散粒剂、OF 油悬、WP 粉剂\n作用：渗透 + 润湿 + 展着 + 增效，提高叶面对药剂吸收，抗雨水冲刷\n涂料 / 油墨:水性涂料、乳液聚合乳化剂、颜料润湿分散\n降表面张力、防缩孔、提高底材润湿\n纺织 / 皮革 / 鞣制加速渗透\n工业清洗:硬表面清洗、低泡渗透剂、油污剥离",
        "data": {
          "spec4": "46–48",
          "spec5": "无色至浅黄色透明微粘液体"
        }
      }
    ]
  },
  {
    "key": "polycarboxylate",
    "slug": "polycarboxylate",
    "name": "聚羧酸盐系列",
    "sheet": "聚羧酸盐",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "pH（5%水溶液）"
    },
    "categories": [
      {
        "key": "聚羧酸盐t38-3",
        "name": "聚羧酸盐T38"
      }
    ],
    "products": [
      {
        "key": "聚羧酸盐t38-3",
        "name": "聚羧酸盐T38",
        "model": "聚羧酸盐T38",
        "intro": "聚羧酸盐T38是一款高性能阴离子型高分子聚羧酸盐分散剂，采用特殊ABA嵌段结构合成，具备优异的静电斥力与空间位阻双重分散性能。产品为白色粉末、冷水易溶，无甲醛、低刺激、环保可降解，广泛适用于农药制剂及各类工业分散、阻垢体系，是替代传统萘系、木质素系分散剂的优质升级产品。。",
        "features": "•分散性能优异：高分子嵌段结构可强力吸附于固体颗粒表面，形成稳定水化层，有效防止颗粒团聚、沉降，大幅提升体系悬浮率与储存稳定性。\n•添加量低、性价比高：相较于传统分散剂，用量更少，低添加量即可实现优异分散效果，不影响制剂理化性能。\n•配伍性极强：与绝大多数农药原药、颜料、填料适配性良好，可与阴离子、非离子助剂复配使用，无拮抗反应。\n•耐候稳定性好：具备良好的耐硬水、耐高温、耐酸碱性能，高低温储存、高硬度水质环境下不易失效。\n•绿色环保：产品不含甲醛、氯离子等有害物质，气味低、毒性小，可生物降解，符合环保生产要求。",
        "scope": "1、农药领域\n专为农药干悬浮剂、水分散粒剂、可湿性粉剂、水悬浮剂设计适配，适用于甲维盐、苯醚甲环唑、啶虫脒、吡蚜酮、噻虫嗪、戊唑醇等各类疏水、难悬浮型杀虫、杀菌、除草剂原药，有效解决制剂分层、沉淀、结块、悬浮率低等问题。\n2、工业领域\n可用于涂料颜料分散、陶瓷粉料分散、造纸填料分散、纺织印染助剂、工业循环水阻垢分散、粉体涂料润湿分散等场景，有效细化颗粒、防止沉降、提升体系均匀度。",
        "data": {
          "spec4": "＞90",
          "spec5": "9-11"
        }
      }
    ]
  },
  {
    "key": "pearlPaste",
    "slug": "pearl-paste",
    "name": "珠光浆系列",
    "sheet": "珠光浆",
    "headerMap": {
      "spec4": "固含量（%）",
      "spec5": "黏度（25℃，mPa·s）"
    },
    "categories": [
      {
        "key": "cp921珠光浆-3",
        "name": "CP921珠光浆"
      }
    ],
    "products": [
      {
        "key": "cp921珠光浆-3",
        "name": "CP921珠光浆",
        "model": "CP921珠光浆",
        "intro": "CP921是高端日化级冷配珠光浓缩液，专为洗发水、沐浴露、洗手液等洗护产品研发。产品无需高温加热，可常温直接添加，成型后呈现细腻高级的绸缎珍珠光泽，兼具温和配方与优异配伍性，是中高端日化洗护产品的优选珠光原料。",
        "features": "1. 常温冷配，节能高效：无需70-80℃高温加热乳化，25-45℃常温即可直接添加，简化生产工艺，降低生产能耗，提升生产效率。\n2. 珠光质感高级细腻：珠光晶体粒径均匀，成型后为柔和绸缎光泽，无粗大颗粒、无泛白浑浊问题，大幅提升日化产品外观档次与质感。\n3. 适配性广泛稳定：含两性、非离子活性组分，可与阴离子、非离子、两性各类表面活性剂完美兼容，不破坏产品原有发泡性、黏度及体系稳定性。\n4. 宽pH适用范围：稳定适配pH4.0-9.0体系，可应用于弱酸性、中性各类温和洗护配方，适配场景更广。\n5. 温和低刺激：配方温和，皮肤、眼黏膜相容性极佳，达到婴儿洗护级安全标准，可用于敏感肌、婴幼儿专用洗护产品。\n6. 附带调理功效：可有效提升头发湿梳顺滑度，减少打结干涩问题，兼具基础护发调理作用。",
        "scope": "1. 洗发水、护发产品：添加量2%-5%，成型光泽自然通透，不导致发丝干涩，兼顾美观与护发效果。\n2. 沐浴露、洗手液：添加量3%-8%，珠光饱满均匀，可搭配绵密泡沫，提升产品整体质感。\n3. 洁面乳、婴儿洗护产品：添加量1.5%-4%，温和无刺激，珠光细腻低调，适配高端温和洗护定位。\n4. 洗衣液、洗洁精等家居洗护：添加量1%-3%，打造均匀乳白珠光观感，提升产品颜值与市场竞争力。",
        "data": {
          "spec4": 25,
          "spec5": 800
        }
      }
    ]
  },
  {
    "key": "tm4",
    "slug": "tm4",
    "name": "脱叶增效剂TM4系列",
    "sheet": "脱叶增效剂TM4",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "pH值（原液）"
    },
    "categories": [
      {
        "key": "脱叶增效剂tm4-3",
        "name": "脱叶增效剂TM4"
      }
    ],
    "products": [
      {
        "key": "脱叶增效剂tm4-3",
        "name": "脱叶增效剂TM4",
        "model": "脱叶增效剂TM4",
        "intro": "本品为噻苯隆类棉花脱叶剂专用桶混增效剂，无直接脱叶作用，需与噻苯隆、敌草隆复配脱叶剂、乙烯利等药剂混用，可大幅提升药液附着、渗透及吸收效果，全方位强化棉花脱叶、催熟功效，是机采棉种植专用高效助剂。",
        "features": "（1）强渗透、高铺展：有效降低药液表面张力，快速润湿棉叶表面，杜绝药液弹跳、漂移、流失问题，大幅提升药液利用率，减少药剂浪费。\n（2）耐低温、耐雨水冲刷：产品稳定性极强，低温环境下仍可保持高活性，12℃低温条件下正常发挥增效作用，完美适配新疆棉田秋季低温脱叶作业场景；药液喷施后成膜性好，抗雨水冲刷，药后遇雨不易失效。\n（3）增效效果显著：可显著提升棉花对脱叶剂、催熟剂的吸收利用率，加快叶片衰老脱落速度，有效解决棉花叶片“干而不落、拖叶挂枝”问题，整体脱叶率可提升10%-20%。\n（4）适配性广、易混用：低泡沫配方设计，无大量泡沫堆积，适配无人机、拖拉机吊杆、人工喷雾等各类作业设备；与市面上绝大多数脱叶剂、乙烯利、叶面肥兼容性极佳，无拮抗反应。",
        "scope": "适用作物：棉花（全国机采棉通用）\n适用场景：棉花采收前脱叶、催熟作业，适配各类田间喷施设备",
        "data": {
          "spec4": 35,
          "spec5": "5-7"
        }
      }
    ]
  }
]

export const catalogByKey = {
  "defoamer": {
    "key": "defoamer",
    "slug": "defoamer",
    "name": "消泡剂系列",
    "sheet": "消泡剂",
    "headerMap": {
      "spec4": "粘度（25℃，cps）",
      "spec5": "比重（25℃，g/cm³）"
    },
    "categories": [
      {
        "key": "df640-4",
        "name": "DF640"
      },
      {
        "key": "df580-5",
        "name": "DF580"
      },
      {
        "key": "df581-6",
        "name": "DF581"
      },
      {
        "key": "df690-7",
        "name": "DF690"
      }
    ],
    "products": [
      {
        "key": "df640-4",
        "name": "DF640",
        "model": "DF640",
        "intro": "无APEO、无溶剂、高环保合规 ，优异的破泡速度与长效抑泡能力 ，高剪切稳定性 ，适配高粘度体系 ，对漆膜光泽无影响",
        "features": "无APEO、无溶剂、高环保合规 ，优异的破泡速度与长效抑泡能力 ，高剪切稳定性",
        "scope": "高端家具漆、工业面漆 、高粘度乳液体系、水性油墨、食品接触级涂料",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.88–0.92"
        }
      },
      {
        "key": "df580-5",
        "name": "DF580",
        "model": "DF580",
        "intro": "通用经济型主力款 ，破泡速度快 ，耐酸碱性能优异 ，不含APEO ，对涂料光泽无影响 ，储存稳定性好 ，全阶段泡沫控制能力",
        "features": "破泡速度快 ，耐酸碱性能优异 ，不含APEO ，对涂料光泽无影响 ，储存稳定性好",
        "scope": "建筑涂料、丝光/高光面漆、水性胶粘剂、乳液合成、农业喷雾、印花色浆",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.91-0.95"
        }
      },
      {
        "key": "df581-6",
        "name": "DF581",
        "model": "DF581",
        "intro": "DF580升级优化款 ，抑泡持久性、储存稳定性显著提升 ，高剪切稳定性，适配高要求建筑涂料与工业涂料 ，无缩孔风险",
        "features": "抑泡持久性、储存稳定性显著提升 ，高剪切稳定性",
        "scope": "中高端建筑涂料、工业面漆、水性胶粘剂、高要求乳液体系、水性木器漆",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.91-0.95"
        }
      },
      {
        "key": "df690-7",
        "name": "DF690",
        "model": "DF690",
        "intro": "快速消泡、消泡持久、经济性突出 ，能在水中快速分散 ，不含硅酮 ，适配多种水性体系 ，耐酸碱 ，储存稳定性好",
        "features": "快速消泡、消泡持久、经济性突出 ，能在水中快速分散 ，适配多种水性体系 ，耐酸碱 ，储存稳定性好",
        "scope": "乳液类涂料、纸品涂料 、农业喷雾、粘合剂、印花色浆、地板清洁化合物、污水处理系统",
        "data": {
          "spec4": "800-1500",
          "spec5": "0.83-0.85"
        }
      }
    ]
  },
  "fastT": {
    "key": "fastT",
    "slug": "fast-t",
    "name": "快T系列",
    "sheet": "快T",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "外观"
    },
    "categories": [
      {
        "key": "快t无水-4",
        "name": "快T(无水)"
      },
      {
        "key": "快t乙醇水-5",
        "name": "快T(乙醇水)"
      },
      {
        "key": "快t溶剂油-6",
        "name": "快T(溶剂油)"
      }
    ],
    "products": [
      {
        "key": "快t无水-4",
        "name": "快T(无水)",
        "model": "快T(无水)",
        "intro": "极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。环保低泡：零 VOC、无 APEO、不易泛黄；50℃以上低泡，低温稳泡。",
        "features": "超强润湿 / 渗透：极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。\n乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。\n环保低泡：零 VOC、无 APEO、不易泛黄；50℃以上低泡，低温稳泡。",
        "scope": "水性体系润湿、分散、抗缩孔，调节水墨粘度。\n农药：乳油 / 水剂渗透剂，提升药液铺展与吸收。\n纺织 / 皮革：渗透、匀染、柔软、抗静电，改善织物抱合性。\n乳液聚合：乳化剂，提高乳液稳定性与粒径控制。\n医药 / 日化：药膏、乳膏乳化分散；洗面奶、沐浴露增溶稳泡。",
        "data": {
          "spec4": "＞98",
          "spec5": "白色 / 类白色结晶粉末或蜡状固体"
        }
      },
      {
        "key": "快t乙醇水-5",
        "name": "快T(乙醇水)",
        "model": "快T(乙醇水)",
        "intro": "极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。环保低泡",
        "features": "超润湿 + 强渗透：极低表面张力，快速铺展、渗透到纤维 / 基材内部\n低泡 / 抑泡：非高泡型，可协同消泡剂，不易起大泡\n乳化稳定：阴离子型，与非离子两性配伍好；乳液聚合常用乳化剂\n低毒、易生物降解：环保型，废水易处理\n抗硬水：耐钙镁离子，适用多种水质",
        "scope": "乳液聚合（丙烯酸 / 苯丙）：乳化剂，提高稳定性、粒径均匀、降低起泡\n涂料 / 油墨：润湿流平、防缩孔 / 鱼眼 / 针孔、改善底材润湿\n胶粘剂 / 压敏胶：涂布防收缩、提高浸润、防针孔 / 流挂\n无纺布 / 纺织：快速渗透纤维、固色 / 粘合更均匀\n水处理 / 金属加工：润湿分散、除油、低泡清洗",
        "data": {
          "spec4": "72–74 ",
          "spec5": "无色至浅黄色透明微粘液体"
        }
      },
      {
        "key": "快t溶剂油-6",
        "name": "快T(溶剂油)",
        "model": "快T(溶剂油)",
        "intro": "真正无水：水分＜0.5%，可溶乳油、油悬剂、粉剂（普通快 T 含水 30–50%，只能做水剂）\n渗透力极强：1% 溶液≤5 秒，比 JFC、氮酮快 3–10 倍\n润湿 + 乳化 + 展着 + 分散四合一\n耐硬水、耐电解质，与多数阴离子 / 非离子复配\n低泡型，适合高浓度配方",
        "features": "真正无水：水分＜0.5%，可溶乳油、油悬剂、粉剂（普通快 T 含水 30–50%，只能做水剂）\n在油性涂层、油墨、胶黏剂、金属加工油中铺展更好\n对金属、玻璃、塑料薄膜难润湿基材依然高效",
        "scope": "农药制剂:EC 乳油、EW 水乳、ME 微乳、SC 悬浮、WG 水分散粒剂、OF 油悬、WP 粉剂\n作用：渗透 + 润湿 + 展着 + 增效，提高叶面对药剂吸收，抗雨水冲刷\n涂料 / 油墨:水性涂料、乳液聚合乳化剂、颜料润湿分散\n降表面张力、防缩孔、提高底材润湿\n纺织 / 皮革 / 鞣制加速渗透\n工业清洗:硬表面清洗、低泡渗透剂、油污剥离",
        "data": {
          "spec4": "46–48",
          "spec5": "无色至浅黄色透明微粘液体"
        }
      }
    ]
  },
  "polycarboxylate": {
    "key": "polycarboxylate",
    "slug": "polycarboxylate",
    "name": "聚羧酸盐系列",
    "sheet": "聚羧酸盐",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "pH（5%水溶液）"
    },
    "categories": [
      {
        "key": "聚羧酸盐t38-3",
        "name": "聚羧酸盐T38"
      }
    ],
    "products": [
      {
        "key": "聚羧酸盐t38-3",
        "name": "聚羧酸盐T38",
        "model": "聚羧酸盐T38",
        "intro": "聚羧酸盐T38是一款高性能阴离子型高分子聚羧酸盐分散剂，采用特殊ABA嵌段结构合成，具备优异的静电斥力与空间位阻双重分散性能。产品为白色粉末、冷水易溶，无甲醛、低刺激、环保可降解，广泛适用于农药制剂及各类工业分散、阻垢体系，是替代传统萘系、木质素系分散剂的优质升级产品。。",
        "features": "•分散性能优异：高分子嵌段结构可强力吸附于固体颗粒表面，形成稳定水化层，有效防止颗粒团聚、沉降，大幅提升体系悬浮率与储存稳定性。\n•添加量低、性价比高：相较于传统分散剂，用量更少，低添加量即可实现优异分散效果，不影响制剂理化性能。\n•配伍性极强：与绝大多数农药原药、颜料、填料适配性良好，可与阴离子、非离子助剂复配使用，无拮抗反应。\n•耐候稳定性好：具备良好的耐硬水、耐高温、耐酸碱性能，高低温储存、高硬度水质环境下不易失效。\n•绿色环保：产品不含甲醛、氯离子等有害物质，气味低、毒性小，可生物降解，符合环保生产要求。",
        "scope": "1、农药领域\n专为农药干悬浮剂、水分散粒剂、可湿性粉剂、水悬浮剂设计适配，适用于甲维盐、苯醚甲环唑、啶虫脒、吡蚜酮、噻虫嗪、戊唑醇等各类疏水、难悬浮型杀虫、杀菌、除草剂原药，有效解决制剂分层、沉淀、结块、悬浮率低等问题。\n2、工业领域\n可用于涂料颜料分散、陶瓷粉料分散、造纸填料分散、纺织印染助剂、工业循环水阻垢分散、粉体涂料润湿分散等场景，有效细化颗粒、防止沉降、提升体系均匀度。",
        "data": {
          "spec4": "＞90",
          "spec5": "9-11"
        }
      }
    ]
  },
  "pearlPaste": {
    "key": "pearlPaste",
    "slug": "pearl-paste",
    "name": "珠光浆系列",
    "sheet": "珠光浆",
    "headerMap": {
      "spec4": "固含量（%）",
      "spec5": "黏度（25℃，mPa·s）"
    },
    "categories": [
      {
        "key": "cp921珠光浆-3",
        "name": "CP921珠光浆"
      }
    ],
    "products": [
      {
        "key": "cp921珠光浆-3",
        "name": "CP921珠光浆",
        "model": "CP921珠光浆",
        "intro": "CP921是高端日化级冷配珠光浓缩液，专为洗发水、沐浴露、洗手液等洗护产品研发。产品无需高温加热，可常温直接添加，成型后呈现细腻高级的绸缎珍珠光泽，兼具温和配方与优异配伍性，是中高端日化洗护产品的优选珠光原料。",
        "features": "1. 常温冷配，节能高效：无需70-80℃高温加热乳化，25-45℃常温即可直接添加，简化生产工艺，降低生产能耗，提升生产效率。\n2. 珠光质感高级细腻：珠光晶体粒径均匀，成型后为柔和绸缎光泽，无粗大颗粒、无泛白浑浊问题，大幅提升日化产品外观档次与质感。\n3. 适配性广泛稳定：含两性、非离子活性组分，可与阴离子、非离子、两性各类表面活性剂完美兼容，不破坏产品原有发泡性、黏度及体系稳定性。\n4. 宽pH适用范围：稳定适配pH4.0-9.0体系，可应用于弱酸性、中性各类温和洗护配方，适配场景更广。\n5. 温和低刺激：配方温和，皮肤、眼黏膜相容性极佳，达到婴儿洗护级安全标准，可用于敏感肌、婴幼儿专用洗护产品。\n6. 附带调理功效：可有效提升头发湿梳顺滑度，减少打结干涩问题，兼具基础护发调理作用。",
        "scope": "1. 洗发水、护发产品：添加量2%-5%，成型光泽自然通透，不导致发丝干涩，兼顾美观与护发效果。\n2. 沐浴露、洗手液：添加量3%-8%，珠光饱满均匀，可搭配绵密泡沫，提升产品整体质感。\n3. 洁面乳、婴儿洗护产品：添加量1.5%-4%，温和无刺激，珠光细腻低调，适配高端温和洗护定位。\n4. 洗衣液、洗洁精等家居洗护：添加量1%-3%，打造均匀乳白珠光观感，提升产品颜值与市场竞争力。",
        "data": {
          "spec4": 25,
          "spec5": 800
        }
      }
    ]
  },
  "tm4": {
    "key": "tm4",
    "slug": "tm4",
    "name": "脱叶增效剂TM4系列",
    "sheet": "脱叶增效剂TM4",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "pH值（原液）"
    },
    "categories": [
      {
        "key": "脱叶增效剂tm4-3",
        "name": "脱叶增效剂TM4"
      }
    ],
    "products": [
      {
        "key": "脱叶增效剂tm4-3",
        "name": "脱叶增效剂TM4",
        "model": "脱叶增效剂TM4",
        "intro": "本品为噻苯隆类棉花脱叶剂专用桶混增效剂，无直接脱叶作用，需与噻苯隆、敌草隆复配脱叶剂、乙烯利等药剂混用，可大幅提升药液附着、渗透及吸收效果，全方位强化棉花脱叶、催熟功效，是机采棉种植专用高效助剂。",
        "features": "（1）强渗透、高铺展：有效降低药液表面张力，快速润湿棉叶表面，杜绝药液弹跳、漂移、流失问题，大幅提升药液利用率，减少药剂浪费。\n（2）耐低温、耐雨水冲刷：产品稳定性极强，低温环境下仍可保持高活性，12℃低温条件下正常发挥增效作用，完美适配新疆棉田秋季低温脱叶作业场景；药液喷施后成膜性好，抗雨水冲刷，药后遇雨不易失效。\n（3）增效效果显著：可显著提升棉花对脱叶剂、催熟剂的吸收利用率，加快叶片衰老脱落速度，有效解决棉花叶片“干而不落、拖叶挂枝”问题，整体脱叶率可提升10%-20%。\n（4）适配性广、易混用：低泡沫配方设计，无大量泡沫堆积，适配无人机、拖拉机吊杆、人工喷雾等各类作业设备；与市面上绝大多数脱叶剂、乙烯利、叶面肥兼容性极佳，无拮抗反应。",
        "scope": "适用作物：棉花（全国机采棉通用）\n适用场景：棉花采收前脱叶、催熟作业，适配各类田间喷施设备",
        "data": {
          "spec4": 35,
          "spec5": "5-7"
        }
      }
    ]
  }
}

export const catalogBySlug = {
  "defoamer": {
    "key": "defoamer",
    "slug": "defoamer",
    "name": "消泡剂系列",
    "sheet": "消泡剂",
    "headerMap": {
      "spec4": "粘度（25℃，cps）",
      "spec5": "比重（25℃，g/cm³）"
    },
    "categories": [
      {
        "key": "df640-4",
        "name": "DF640"
      },
      {
        "key": "df580-5",
        "name": "DF580"
      },
      {
        "key": "df581-6",
        "name": "DF581"
      },
      {
        "key": "df690-7",
        "name": "DF690"
      }
    ],
    "products": [
      {
        "key": "df640-4",
        "name": "DF640",
        "model": "DF640",
        "intro": "无APEO、无溶剂、高环保合规 ，优异的破泡速度与长效抑泡能力 ，高剪切稳定性 ，适配高粘度体系 ，对漆膜光泽无影响",
        "features": "无APEO、无溶剂、高环保合规 ，优异的破泡速度与长效抑泡能力 ，高剪切稳定性",
        "scope": "高端家具漆、工业面漆 、高粘度乳液体系、水性油墨、食品接触级涂料",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.88–0.92"
        }
      },
      {
        "key": "df580-5",
        "name": "DF580",
        "model": "DF580",
        "intro": "通用经济型主力款 ，破泡速度快 ，耐酸碱性能优异 ，不含APEO ，对涂料光泽无影响 ，储存稳定性好 ，全阶段泡沫控制能力",
        "features": "破泡速度快 ，耐酸碱性能优异 ，不含APEO ，对涂料光泽无影响 ，储存稳定性好",
        "scope": "建筑涂料、丝光/高光面漆、水性胶粘剂、乳液合成、农业喷雾、印花色浆",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.91-0.95"
        }
      },
      {
        "key": "df581-6",
        "name": "DF581",
        "model": "DF581",
        "intro": "DF580升级优化款 ，抑泡持久性、储存稳定性显著提升 ，高剪切稳定性，适配高要求建筑涂料与工业涂料 ，无缩孔风险",
        "features": "抑泡持久性、储存稳定性显著提升 ，高剪切稳定性",
        "scope": "中高端建筑涂料、工业面漆、水性胶粘剂、高要求乳液体系、水性木器漆",
        "data": {
          "spec4": "1000-1500",
          "spec5": "0.91-0.95"
        }
      },
      {
        "key": "df690-7",
        "name": "DF690",
        "model": "DF690",
        "intro": "快速消泡、消泡持久、经济性突出 ，能在水中快速分散 ，不含硅酮 ，适配多种水性体系 ，耐酸碱 ，储存稳定性好",
        "features": "快速消泡、消泡持久、经济性突出 ，能在水中快速分散 ，适配多种水性体系 ，耐酸碱 ，储存稳定性好",
        "scope": "乳液类涂料、纸品涂料 、农业喷雾、粘合剂、印花色浆、地板清洁化合物、污水处理系统",
        "data": {
          "spec4": "800-1500",
          "spec5": "0.83-0.85"
        }
      }
    ]
  },
  "fast-t": {
    "key": "fastT",
    "slug": "fast-t",
    "name": "快T系列",
    "sheet": "快T",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "外观"
    },
    "categories": [
      {
        "key": "快t无水-4",
        "name": "快T(无水)"
      },
      {
        "key": "快t乙醇水-5",
        "name": "快T(乙醇水)"
      },
      {
        "key": "快t溶剂油-6",
        "name": "快T(溶剂油)"
      }
    ],
    "products": [
      {
        "key": "快t无水-4",
        "name": "快T(无水)",
        "model": "快T(无水)",
        "intro": "极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。环保低泡：零 VOC、无 APEO、不易泛黄；50℃以上低泡，低温稳泡。",
        "features": "超强润湿 / 渗透：极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。\n乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。\n环保低泡：零 VOC、无 APEO、不易泛黄；50℃以上低泡，低温稳泡。",
        "scope": "水性体系润湿、分散、抗缩孔，调节水墨粘度。\n农药：乳油 / 水剂渗透剂，提升药液铺展与吸收。\n纺织 / 皮革：渗透、匀染、柔软、抗静电，改善织物抱合性。\n乳液聚合：乳化剂，提高乳液稳定性与粒径控制。\n医药 / 日化：药膏、乳膏乳化分散；洗面奶、沐浴露增溶稳泡。",
        "data": {
          "spec4": "＞98",
          "spec5": "白色 / 类白色结晶粉末或蜡状固体"
        }
      },
      {
        "key": "快t乙醇水-5",
        "name": "快T(乙醇水)",
        "model": "快T(乙醇水)",
        "intro": "极低表面张力，快速铺展，难润湿基材（金属、玻璃、铝材）效果优异。乳化 / 分散稳定：与多数聚合物相容，作乳化剂、分散剂，防沉降、抗静电、耐低温。环保低泡",
        "features": "超润湿 + 强渗透：极低表面张力，快速铺展、渗透到纤维 / 基材内部\n低泡 / 抑泡：非高泡型，可协同消泡剂，不易起大泡\n乳化稳定：阴离子型，与非离子两性配伍好；乳液聚合常用乳化剂\n低毒、易生物降解：环保型，废水易处理\n抗硬水：耐钙镁离子，适用多种水质",
        "scope": "乳液聚合（丙烯酸 / 苯丙）：乳化剂，提高稳定性、粒径均匀、降低起泡\n涂料 / 油墨：润湿流平、防缩孔 / 鱼眼 / 针孔、改善底材润湿\n胶粘剂 / 压敏胶：涂布防收缩、提高浸润、防针孔 / 流挂\n无纺布 / 纺织：快速渗透纤维、固色 / 粘合更均匀\n水处理 / 金属加工：润湿分散、除油、低泡清洗",
        "data": {
          "spec4": "72–74 ",
          "spec5": "无色至浅黄色透明微粘液体"
        }
      },
      {
        "key": "快t溶剂油-6",
        "name": "快T(溶剂油)",
        "model": "快T(溶剂油)",
        "intro": "真正无水：水分＜0.5%，可溶乳油、油悬剂、粉剂（普通快 T 含水 30–50%，只能做水剂）\n渗透力极强：1% 溶液≤5 秒，比 JFC、氮酮快 3–10 倍\n润湿 + 乳化 + 展着 + 分散四合一\n耐硬水、耐电解质，与多数阴离子 / 非离子复配\n低泡型，适合高浓度配方",
        "features": "真正无水：水分＜0.5%，可溶乳油、油悬剂、粉剂（普通快 T 含水 30–50%，只能做水剂）\n在油性涂层、油墨、胶黏剂、金属加工油中铺展更好\n对金属、玻璃、塑料薄膜难润湿基材依然高效",
        "scope": "农药制剂:EC 乳油、EW 水乳、ME 微乳、SC 悬浮、WG 水分散粒剂、OF 油悬、WP 粉剂\n作用：渗透 + 润湿 + 展着 + 增效，提高叶面对药剂吸收，抗雨水冲刷\n涂料 / 油墨:水性涂料、乳液聚合乳化剂、颜料润湿分散\n降表面张力、防缩孔、提高底材润湿\n纺织 / 皮革 / 鞣制加速渗透\n工业清洗:硬表面清洗、低泡渗透剂、油污剥离",
        "data": {
          "spec4": "46–48",
          "spec5": "无色至浅黄色透明微粘液体"
        }
      }
    ]
  },
  "polycarboxylate": {
    "key": "polycarboxylate",
    "slug": "polycarboxylate",
    "name": "聚羧酸盐系列",
    "sheet": "聚羧酸盐",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "pH（5%水溶液）"
    },
    "categories": [
      {
        "key": "聚羧酸盐t38-3",
        "name": "聚羧酸盐T38"
      }
    ],
    "products": [
      {
        "key": "聚羧酸盐t38-3",
        "name": "聚羧酸盐T38",
        "model": "聚羧酸盐T38",
        "intro": "聚羧酸盐T38是一款高性能阴离子型高分子聚羧酸盐分散剂，采用特殊ABA嵌段结构合成，具备优异的静电斥力与空间位阻双重分散性能。产品为白色粉末、冷水易溶，无甲醛、低刺激、环保可降解，广泛适用于农药制剂及各类工业分散、阻垢体系，是替代传统萘系、木质素系分散剂的优质升级产品。。",
        "features": "•分散性能优异：高分子嵌段结构可强力吸附于固体颗粒表面，形成稳定水化层，有效防止颗粒团聚、沉降，大幅提升体系悬浮率与储存稳定性。\n•添加量低、性价比高：相较于传统分散剂，用量更少，低添加量即可实现优异分散效果，不影响制剂理化性能。\n•配伍性极强：与绝大多数农药原药、颜料、填料适配性良好，可与阴离子、非离子助剂复配使用，无拮抗反应。\n•耐候稳定性好：具备良好的耐硬水、耐高温、耐酸碱性能，高低温储存、高硬度水质环境下不易失效。\n•绿色环保：产品不含甲醛、氯离子等有害物质，气味低、毒性小，可生物降解，符合环保生产要求。",
        "scope": "1、农药领域\n专为农药干悬浮剂、水分散粒剂、可湿性粉剂、水悬浮剂设计适配，适用于甲维盐、苯醚甲环唑、啶虫脒、吡蚜酮、噻虫嗪、戊唑醇等各类疏水、难悬浮型杀虫、杀菌、除草剂原药，有效解决制剂分层、沉淀、结块、悬浮率低等问题。\n2、工业领域\n可用于涂料颜料分散、陶瓷粉料分散、造纸填料分散、纺织印染助剂、工业循环水阻垢分散、粉体涂料润湿分散等场景，有效细化颗粒、防止沉降、提升体系均匀度。",
        "data": {
          "spec4": "＞90",
          "spec5": "9-11"
        }
      }
    ]
  },
  "pearl-paste": {
    "key": "pearlPaste",
    "slug": "pearl-paste",
    "name": "珠光浆系列",
    "sheet": "珠光浆",
    "headerMap": {
      "spec4": "固含量（%）",
      "spec5": "黏度（25℃，mPa·s）"
    },
    "categories": [
      {
        "key": "cp921珠光浆-3",
        "name": "CP921珠光浆"
      }
    ],
    "products": [
      {
        "key": "cp921珠光浆-3",
        "name": "CP921珠光浆",
        "model": "CP921珠光浆",
        "intro": "CP921是高端日化级冷配珠光浓缩液，专为洗发水、沐浴露、洗手液等洗护产品研发。产品无需高温加热，可常温直接添加，成型后呈现细腻高级的绸缎珍珠光泽，兼具温和配方与优异配伍性，是中高端日化洗护产品的优选珠光原料。",
        "features": "1. 常温冷配，节能高效：无需70-80℃高温加热乳化，25-45℃常温即可直接添加，简化生产工艺，降低生产能耗，提升生产效率。\n2. 珠光质感高级细腻：珠光晶体粒径均匀，成型后为柔和绸缎光泽，无粗大颗粒、无泛白浑浊问题，大幅提升日化产品外观档次与质感。\n3. 适配性广泛稳定：含两性、非离子活性组分，可与阴离子、非离子、两性各类表面活性剂完美兼容，不破坏产品原有发泡性、黏度及体系稳定性。\n4. 宽pH适用范围：稳定适配pH4.0-9.0体系，可应用于弱酸性、中性各类温和洗护配方，适配场景更广。\n5. 温和低刺激：配方温和，皮肤、眼黏膜相容性极佳，达到婴儿洗护级安全标准，可用于敏感肌、婴幼儿专用洗护产品。\n6. 附带调理功效：可有效提升头发湿梳顺滑度，减少打结干涩问题，兼具基础护发调理作用。",
        "scope": "1. 洗发水、护发产品：添加量2%-5%，成型光泽自然通透，不导致发丝干涩，兼顾美观与护发效果。\n2. 沐浴露、洗手液：添加量3%-8%，珠光饱满均匀，可搭配绵密泡沫，提升产品整体质感。\n3. 洁面乳、婴儿洗护产品：添加量1.5%-4%，温和无刺激，珠光细腻低调，适配高端温和洗护定位。\n4. 洗衣液、洗洁精等家居洗护：添加量1%-3%，打造均匀乳白珠光观感，提升产品颜值与市场竞争力。",
        "data": {
          "spec4": 25,
          "spec5": 800
        }
      }
    ]
  },
  "tm4": {
    "key": "tm4",
    "slug": "tm4",
    "name": "脱叶增效剂TM4系列",
    "sheet": "脱叶增效剂TM4",
    "headerMap": {
      "spec4": "有效成分（%）",
      "spec5": "pH值（原液）"
    },
    "categories": [
      {
        "key": "脱叶增效剂tm4-3",
        "name": "脱叶增效剂TM4"
      }
    ],
    "products": [
      {
        "key": "脱叶增效剂tm4-3",
        "name": "脱叶增效剂TM4",
        "model": "脱叶增效剂TM4",
        "intro": "本品为噻苯隆类棉花脱叶剂专用桶混增效剂，无直接脱叶作用，需与噻苯隆、敌草隆复配脱叶剂、乙烯利等药剂混用，可大幅提升药液附着、渗透及吸收效果，全方位强化棉花脱叶、催熟功效，是机采棉种植专用高效助剂。",
        "features": "（1）强渗透、高铺展：有效降低药液表面张力，快速润湿棉叶表面，杜绝药液弹跳、漂移、流失问题，大幅提升药液利用率，减少药剂浪费。\n（2）耐低温、耐雨水冲刷：产品稳定性极强，低温环境下仍可保持高活性，12℃低温条件下正常发挥增效作用，完美适配新疆棉田秋季低温脱叶作业场景；药液喷施后成膜性好，抗雨水冲刷，药后遇雨不易失效。\n（3）增效效果显著：可显著提升棉花对脱叶剂、催熟剂的吸收利用率，加快叶片衰老脱落速度，有效解决棉花叶片“干而不落、拖叶挂枝”问题，整体脱叶率可提升10%-20%。\n（4）适配性广、易混用：低泡沫配方设计，无大量泡沫堆积，适配无人机、拖拉机吊杆、人工喷雾等各类作业设备；与市面上绝大多数脱叶剂、乙烯利、叶面肥兼容性极佳，无拮抗反应。",
        "scope": "适用作物：棉花（全国机采棉通用）\n适用场景：棉花采收前脱叶、催熟作业，适配各类田间喷施设备",
        "data": {
          "spec4": 35,
          "spec5": "5-7"
        }
      }
    ]
  }
}

export function getSeriesBySlug(slug) {
  return catalogBySlug[slug] || null
}

export function getProductByKey(series, productKey) {
  if (!series) return null
  return series.products.find((p) => p.key === productKey) || null
}
